import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('streamManagementStore')
@observer
class StreamManagement extends Component {
  render() {
    const { streamManagementStore } = this.props
    const { isFetching } = streamManagementStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default StreamManagement;
